export default "__VITE_ASSET__Cau4l8aZ__"